import AuthContext from 'context/AuthContext';
import React, { useContext, useEffect, useState } from 'react';
import { getHostBadgeStats } from 'Services/badgeAnalyticsService';

const MyBadgeStats = () => {
  const { user } = useContext(AuthContext);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) return;
    getHostBadgeStats({ hostId: user.uid, range: '7d' })
      .then((res) => setStats(res?.data?.data || res?.data || null))
      .catch((err) => {
        console.error('MyBadgeStats fetch error:', err);
        setStats({
          impressions_on_my_demos: 0,
          clicks: 0,
          ctr_pct: 0,
          group_meetings: 0,
          extra_guest_revenue: 0,
          minutes_live_with_allow: 0,
        });
      })
      .finally(() => setLoading(false));
  }, [user?.uid]);

  if (loading) {
    return (
      <div className="card mb-3">
        <div className="card-body">
          <h6 className="card-title">My Badge Stats (Last 7 days)</h6>
          <div style={{ height: '1.5rem', background: '#e0e0e0', borderRadius: 4, width: '80%' }} />
        </div>
      </div>
    );
  }

  if (!stats) return null;

  const impressions = stats.impressions_on_my_demos ?? stats.impressions ?? 0;
  const clicks = stats.clicks ?? 0;
  const ctr =
    stats.ctr_pct != null
      ? Number(stats.ctr_pct).toFixed(1)
      : impressions > 0
      ? ((clicks / impressions) * 100).toFixed(1)
      : '0.0';
  const groupMeetings = stats.group_meetings ?? 0;
  const extraRevenue = Number(stats.extra_guest_revenue ?? 0);
  const minutesLive = stats.minutes_live_with_allow ?? 0;

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title">My Badge Stats (Last 7 days)</h6>
        <div className="row text-center">
          <div className="col">
            <p className="mb-0 h5">{impressions.toLocaleString()}</p>
            <small className="text-muted">Impressions</small>
          </div>
          <div className="col">
            <p className="mb-0 h5">{clicks.toLocaleString()}</p>
            <small className="text-muted">Clicks</small>
          </div>
          <div className="col">
            <p className="mb-0 h5">{ctr}%</p>
            <small className="text-muted">CTR</small>
          </div>
          <div className="col">
            <p className="mb-0 h5">{groupMeetings.toLocaleString()}</p>
            <small className="text-muted">Group Meetings</small>
          </div>
        </div>
        {extraRevenue > 0 && (
          <p className="mt-2 mb-0 small text-success">
            Earned ${extraRevenue.toFixed(2)} from extra guests
          </p>
        )}
        {minutesLive > 0 && (
          <p className="mt-1 mb-0 small text-muted">
            You were live with Allow on for {minutesLive} minutes this week
          </p>
        )}
      </div>
    </div>
  );
};

export default MyBadgeStats;
